import { Divider, Typography, Box, TextField, Grid2, Button, Backdrop, CircularProgress } from "@mui/material";
import { useContext, useState } from "react";
import { Context } from '../../App';
import { useEffect } from "react";
import { useMemo } from "react";

export default function AdmPaymentForm({payment, close, updatePayments}) {
    const gridItemSize = {xs: 12, xl: 6};
    const {setIsConnected} = useContext(Context);
    const user = JSON.parse(sessionStorage.getItem('user'));

    const [load, setLoad] = useState(true);
    const [events, setEvents] = useState([]);
    const [eventId, setEventId] = useState(payment?.envent || '');
    const [sellInfo, setSellInfo] = useState({ count: 0, recette: 0 });

    const [form, setForm] = useState(payment?.rib || { titulaire: '', iban: '', bic: ''});
    const [errors, setErrors] = useState({});

    const event = useMemo(()=> events.find(e => e._id === eventId), [events, eventId]);
    const amount = useMemo(()=> !!payment ? payment.amount : sellInfo?.recette ? (sellInfo.recette-(Math.round(sellInfo.recette * 0.03*100)/100)) : 0, [payment, sellInfo]);

    const formatIban = (value) => {
        const raw = value.replace(/\s+/g, '').replace(/[^A-Z0-9]/gi, '').toUpperCase();
        const limited = raw.slice(0, 27); // limite à 34 caractères sans espace
        return limited.replace(/(.{4})/g, '$1 ').trim(); // ajoute espaces tous les 4 caractères
    };


    const handleChange = (e) => {
        if (e.target.name === 'iban') {
            setForm({ ...form, [e.target.name]: formatIban(e.target.value) });
            setErrors({ ...errors, iban: '' }); // Réinitialiser l'erreur à chaque changement
        } else if (e.target.name === 'bic') {
            setForm({ ...form, [e.target.name]: e.target.value.toUpperCase() });
            setErrors({ ...errors, bic: '' }); // Réinitialiser l'erreur à chaque changement
        } else  setForm({ ...form, [e.target.name]: e.target.value });
    };

    const validate = () => {
        const newErrors = {};
        if (!form.titulaire.trim()) newErrors.titulaire = 'Champ requis';
        const iban = form.iban.replace(/\s/g, '').toUpperCase();
        if (!/^FR\d{2}\d{5}\d{5}\d{11}\d{2}$/.test(iban))
        newErrors.iban = 'IBAN invalide (ex: FR76 XXXX XXXX XXXX XXXX XXXX XXX)';
        if (!/^[A-Z0-9]{8,11}$/.test(form.bic.toUpperCase()))
        newErrors.bic = 'BIC invalide';
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length) {
            setErrors(validationErrors);
        } else {
            setErrors({});
            const paymentData = {
                user: user._id,
                event: eventId,
                amount,
                recette: sellInfo.recette,
                rib: form
            }
            setLoad(true);

            const query = payment ? new URLSearchParams({ _id: payment._id }).toString() : '';

            fetch(process.env.REACT_APP_API_URL +(payment ? ('/adm/payment?'+query) : '/adm/payments/create'), {
                method: !!payment ? 'PATCH' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`
                },
                body: JSON.stringify(!!payment ? {rib: form} : paymentData)
            }).then(async response => {
                const token = response.headers.get('x-auth-token');
                if (response.status === 401) {
                    sessionStorage.clear();
                    setIsConnected(false);
                } else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        updatePayments(json);
                        close();
                    } else {
                        const error = await response.json();
                        console.error('Erreur lors de la soumission de la demande de paiement:', error);
                        setErrors({ submit: error.message || 'Erreur lors de la soumission' });
                    }
                }
            }).catch(error => {
                console.error("Erreur lors de la soumission de la demande de paiement:", error);
                setErrors({ submit: 'Erreur de connexion, veuillez réessayer plus tard.' });
            }).finally(() => {
                setLoad(false);
            });
        }
    };

    useEffect(() => {
        if (!event || eventId=== '' || !!payment) return setLoad(false);

         fetch(`${process.env.REACT_APP_API_URL}/adm/events/${eventId}/sell`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    if (json && json._id) delete json._id; // Remove _id if not needed

                    setSellInfo(json || { count: 0, recette: 0 });   
                }
            }
        }).catch(error => {
            console.error("Error fetching event details:", error);
        }).finally(() => {
            setLoad(false);
        });

    }, [event])

    useEffect(()=> {
        if(!user) return;
        if (user.role === 'user') {
            sessionStorage.clear();
            setIsConnected(false);
            return;
        }

        fetch(process.env.REACT_APP_API_URL+'/events', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, body: JSON.stringify(!!payment ? {_id: payment.event} : {_id: {$in: user.events}})
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setEvents(json);
                    if (json.length === 1) {
                        setEventId(json[0]._id || "");
                    }
                }
            }
        }).catch(error => {
            console.error("Error fetching events:", error);
        // }).finally(() => {
            setLoad(false);
        });
    }, [])

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', px: 2}}>
            <Typography variant="h6" align="center" color="focus" sx={{my: 2 }}>Demande de paiement</Typography>

            {events.length === 1 || !!payment ? 
                <Typography variant="subtitle1">{event?.titre}</Typography> 
                : 
                <TextField select label="Événement" value={eventId} slotProps={{select: {native: true}, inputLabel: {shrink: true}}} size="small"
                onChange={e => setEventId(e.target.value)} sx={{width: '80%', minWidth: 200}}>
                    <option value="">Sélectionner un événement</option>
                    {events.map(e => <option key={e._id} value={e._id}>{e.titre}</option>)}
                </TextField>
            }

            {!!event && <Box ml={4} mb={1}>
                <Typography variant="body1">Recette: {amount.toFixed(2)} €</Typography>
                {!payment && <Typography variant="body1">Billets vendus: {sellInfo.count}</Typography>}
            </Box>}

            <Divider variant="middle" sx={{width: '60%', alignSelf:'center', mt:1, mb:2}}/>
            <Typography variant="subtitle1">Informations bancaires (RIB)</Typography>

            <Box component="form" onSubmit={handleSubmit} p={2} sx={{display: 'flex', flexDirection: 'column', gap: 2}}>

                <Grid2 container spacing={2} mb={2}>
                    <Grid2 size={gridItemSize}>
                    <TextField required
                        label="Titulaire du compte"
                        name="titulaire"
                        value={form.titulaire}
                        onChange={handleChange}
                        fullWidth
                        error={!!errors.titulaire}
                        helperText={errors.titulaire}
                    />
                    </Grid2>

                    <Grid2 size={gridItemSize}>
                    <TextField required
                        label="IBAN"
                        name="iban"
                        value={form.iban}
                        onChange={handleChange}
                        slotProps={{input: {maxLength: 34}}}
                        fullWidth
                        error={!!errors.iban}
                        helperText={errors.iban}
                        placeholder="FR76 XXXX XXXX XXXX XXXX XXXX XXX"
                    />
                    </Grid2>

                    <Grid2 size={gridItemSize}>
                    <TextField required
                        label="BIC / SWIFT"
                        name="bic"
                        value={form.bic}
                        onChange={handleChange}
                        fullWidth
                        error={!!errors.bic}
                        helperText={errors.bic}
                        placeholder="ex: PSSTFRPPXXX"
                    />
                    </Grid2>
                </Grid2>

                <Button variant="contained" type="submit" color="focus" sx={{alignSelf: 'center', color:'white'}}>{payment ? 'Modifier ma demande' : 'Soumettre ma demande'}</Button>
            </Box>

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    );
}